<template>
  <div class="maintenance">
    <h1>メンテナンス中です</h1>
    <p>ただいまシステムメンテナンス中です。<br>しばらく時間をおいて再度アクセスしてください。</p>
  </div>
</template>

<script>
export default { name: 'Maintenance' }
</script>

<style scoped>
.maintenance {
  text-align: center;
  padding: 4rem 1rem;
  color: #333;
  font-family: system-ui, -apple-system, sans-serif;
}
.maintenance h1 { margin-bottom: 1rem; }
.maintenance p { color: #666; }
</style>
